export default {
  "Loop as a GIF": "GIF के रूप में लूप करें",
  "without sound": "आवाज़ के बिना",
  "Final output duration": "अंतिम आउटपुट की अवधि",
};
